import useUsersMeQuery from '~queries/messenger/useUsersMe';

const useFetchUserInfo = (isWebView = false) => {
  const { data, ...options } = useUsersMeQuery(isWebView);

  return { data: data || null, ...options };
};

export default useFetchUserInfo;
